import React from 'react';
import styled from 'styled-components';
import { Group, useBreakpoint } from '@landr/maestro';
import MetasBadge from 'components/MetasBadge/MetasBadge';
import { DetailsProps, SlideTypes } from '../types';
import Byline from './Byline';
import Title from './Title';
import CallToActions from './CallToActions';
import Description from './Description';

export const DetailsWrapper = styled(Group.Item)`
    position: relative;
    width: 430px;
    max-width: 40%;

    ${({ theme }): string => theme.breakpoint('md')`
        width: 100%;
        max-width: none;
    `}
`;

const Details = ({ details, isLoading = false }: DetailsProps) => {
    const isVertical = useBreakpoint('md');

    return (
        <DetailsWrapper>
            <Byline
                content={details?.byline}
                isLoading={isLoading}
                isVertical={isVertical}
                isUppercase={details?.type === SlideTypes.Custom ? false : true}
            />
            <Title
                content={details?.title}
                isLoading={isLoading}
                isVertical={isVertical}
            />
            <MetasBadge
                metas={details?.tags}
                isLoading={isLoading}
                mb="md"
                gutter="xs"
            />

            {!isVertical && (
                <Description
                    content={details?.description}
                    isLoading={isLoading}
                />
            )}
            <CallToActions
                isLoading={isLoading}
                demoGuid={details?.demoGuid}
                isVertical={isVertical}
                type={details?.type}
                slug={details?.slug}
                customExternalUrl={details?.customExternalUrl}
                playDemoCallback={details?.playDemoCallback}
            />
        </DetailsWrapper>
    );
};

export default Details;
